import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import React from "react";

const ReusableSelect = ({
  label,
  value,
  name,
  handleChange,
  data,
  labelId,
  id,
}) => {
  return (
    <div>
      <FormControl fullWidth>
        <InputLabel id={labelId}>{label}</InputLabel>
        <Select
          id={id}
          labelId={labelId}
          label={label}
          displayEmpty
          value={value}
          name={name}
          size="small"
          onChange={(event) => handleChange(event)}
        >
          {/* <MenuItem value="" disabled>
            {label}
          </MenuItem> */}
          {data.map((item, i) => {
            return (
              <MenuItem value={item.label} key={i}>
                {item.label}
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>
    </div>
  );
};

export default ReusableSelect;
